<template>
<section class="welcome">
    <div class="left">
        <div class="left-content">
            <router-link to="/"><h1>Комфортний <br> Слов'янськ</h1></router-link>
            <h6 class="subtitle">Відкриті дані для розумного міста!</h6>
            <a href="#tab" class="hu button" @click.prevent="scrollToMain()">Переглянути проєкт</a>
        </div>
    </div>

    <div class="right"></div>
    <div class="logos">
        <img src="../assets/welcome/MIN.png" alt="Міністерство Цифр" style="height: 80%">    
        <img src="../assets/welcome/slovjansk_logo.svg" alt="Герб Слов'янська" style="height: 90%;">
        <img src="../assets/welcome/uk-aid-logo-transparent.png" alt="ukaid" style="height: 70%;">
        <img src="../assets/welcome/usaid-logo-transparent.png" alt="usaid" style="height: 60%;">
        <img src="../assets/welcome/eurasia-foundation-logo-transparent.png" style="height: 60%;" alt="Eurasia foundation">
        <img src="../assets/welcome/texty.png" alt="texty.org.ua" style="height: 60%;">        
    </div>

</section>
</template>

<script>
export default {
    name: "welcome-bar",
    
    methods: {
        scrollToMain(e) {
            document.querySelector("#tab").scrollIntoView({behavior: 'smooth'})
        }
    },

}
</script>

<style lang="scss" scoped>
@import '../assets/scss/base/variables';

$pad-left: 7vw;

h1 {
    font-family: 'e-UkraineHead';
    font-size: 4vw;
    line-height: 5vw;
    font-weight: 500;

    margin: 0;
    margin-bottom: 0.3em;
}

.welcome {
    display: grid;
    height: 100vh;
    grid-template-columns: [start] 1fr [middle] 1fr [end];
    grid-template-rows: [start] auto [logos-start] max-content [end];
}

.left {
    grid-column: start/middle;
    grid-row: start/end;
    background-color: #86D1F5;

    display: flex;
    flex-flow: column;
    justify-content: center;
    padding-left: $pad-left;
}

.right {
    grid-column: middle/end;
    grid-row: start/end;
    background-image: url('../assets/welcome/satelite.jpg');
}

.logos {
    grid-column: start/end;
    grid-row: logos-start;
    background-color: transparentize($color: #ffffff, $amount: 0.2);
    
    height: 5vw;
    display: flex;

    justify-content: space-between;
    align-items: center;
    

    padding-left: $pad-left;
    padding-right: $pad-left;

    img {
        height: 100%;
    }
}

.left-content {
    display: flex;
    flex-direction: column;
}

@media screen and (max-width: 800px){
    h1 {
        font-size: 11.1vw;
        line-height: 1.3;

        // > * {margin: 0 auto;}
    }
    
    .welcome {
        // display: block;
        grid-template-columns: [start] 1fr [end];
        grid-template-rows: [start] auto [logos-start] max-content [end];
    }

    .left {
        padding: 0 30px;

        grid-column: start/end;
        grid-row: start/logos-start;
    }

    .right {
        display: none;
    }

    .logos {
        height: auto;
        gap: 1em;
        padding: 1em 30px;
        flex-wrap: wrap;

        img {
            // margin: 0.5em;
            height: 44px !important;
        }
    }

    .button.hu {
        max-width: 100%;
    }
}

@media screen and (max-width: 440px) {
    .logos {
        padding: 1em 0;
        gap: 0;
    }

    .logos > img {
        transform: scale(0.8);
        margin-bottom: 1em;
    }
}


</style>
